var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Input',_vm._b({attrs:{"value":_vm.value,"type":_vm.inputType},on:{"input":_vm.onInput},scopedSlots:_vm._u([{key:"rightIcons",fn:function(){return [_c('Icon',{staticClass:"icon-password",attrs:{"name":_vm.iconName,"handleClick":_vm.toggleVisible}})]},proxy:true}])},'Input',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }